import { Component, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-2column',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="page-2column">
      <div class="left-column">
        <ng-container [ngTemplateOutlet]="leftColumnTpl"></ng-container>
      </div>
      <div class="right-column">
        <ng-container [ngTemplateOutlet]="rightColumnTpl"></ng-container>
      </div>
    </div>
  `,
  styles: [`
    .page-2column {
      display: grid;
      grid-template-columns: 1fr 315px;
      gap: 14px;
      margin-top: 14px;
    }
  `]
})
export class Page2ColumnComponent {
  @ContentChild('leftColumn', { static: true }) leftColumnTpl!: TemplateRef<any>;
  @ContentChild('rightColumn', { static: true }) rightColumnTpl!: TemplateRef<any>;
}
